<template>
  <div class="alice-empty">
    <div class="alice-empty__pattern" aria-hidden="true">
      <VP1Pattern :size="64" :opacity="0.06" />
    </div>
    <div class="alice-empty__inner">
      <div class="alice-empty__headline">Geen resultaat.</div>
      <div class="alice-empty__body">
        <template v-if="query">
          Niets gevonden voor
          <span class="alice-empty__query">"{{ query }}"</span>. Probeer een
          andere klant of methode.
        </template>
        <template v-else>
          Er zijn nog geen projecten. Klik op "New project" om er een te
          starten.
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VP1Pattern from "./VP1Pattern.vue";

export default {
  name: "AliceEmptyState",
  components: { VP1Pattern },
  props: {
    query: { type: String, default: "" },
  },
};
</script>

<style scoped>
.alice-empty {
  position: relative;
  padding: 80px 40px;
  text-align: center;
  overflow: hidden;
  border-bottom: 1px solid var(--border-hairline);
  background: var(--vp-white);
}
.alice-empty__pattern {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.alice-empty__inner {
  position: relative;
  max-width: 480px;
  margin: 0 auto;
}
.alice-empty__headline {
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--vp-black);
  letter-spacing: -0.01em;
}
.alice-empty__body {
  font-family: var(--font-body);
  font-size: 18px;
  color: var(--fg-2);
  line-height: 1.5;
}
.alice-empty__query {
  background: var(--accent-20);
  padding: 1px 6px;
}
</style>
